import axios from "axios";
const API = axios.create({ baseURL: "https://api.miksanplastik.com.tr" });
export default API;
API.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
export const login = (data) => API.post("/api/auth/login", data);
// Faz BP-polish (2026-05-13): admin panel sifremi-unuttum akisi.
// Backend cevabi her zaman ayni (timing leak korumasi), basari/hata fark etmez.
export const forgotPassword = (email) => API.post("/api/auth/forgot-password", { email });
export const resetPassword = (token, password) => API.post("/api/auth/reset-password", { token, password });
export const getProducts = () => API.get("/api/products");
export const createProduct = (data) => API.post("/api/products", data);
export const updateProduct = (id, data) => API.put(`/api/products/${id}`, data);
export const getOrders = () => API.get("/api/orders");
export const getOrdersAll = (status) => API.get("/api/orders/all" + (status ? `?status=${status}` : ""));
export const updateOrderStatus = (id, data) => API.put(`/api/orders/${id}/status`, data);
export const getOrderDetails = (id) => API.get(`/api/orders/${id}`);
export const getUsers = () => API.get("/api/users");
export const createUser = (data) => API.post("/api/users", data);
export const getCategories = () => API.get("/api/categories");
export const createCategory = (data) => API.post("/api/categories", data);
export const updateCategory = (id, data) => API.put(`/api/categories/${id}`, data);
export const deleteCategory = (id) => API.delete(`/api/categories/${id}`);
export const getSuppliers = () => API.get("/api/products/suppliers");
export const getAdminStats = () => API.get("/api/admin/stats");
export const getPendingUsers = () => API.get("/api/users/pending");
export const approveUser = (id) => API.put(`/api/users/${id}/approve`);
export const rejectUser = (id) => API.put(`/api/users/${id}/reject`);

// =============================================================================
// Faz E.1 (2026-05-10): Kullanici-bazli KDV gorunum override
// =============================================================================
// PUT /api/admin/b2b/users/:userId/group endpoint'i hem grup atama hem KDV
// override icin kullaniliyor. Bu helper sadece KDV alani gonderir.
//
// value: 'group' | null  -> users.shows_vat_inclusive = NULL (grup default'a don)
//        1 / true        -> KDV dahil goster
//        0 / false       -> KDV haric goster
// =============================================================================
export const setUserVatPreference = (userId, value) =>
  API.put(`/api/admin/b2b/users/${userId}/group`, { shows_vat_inclusive: value });
export const deleteProduct = (id) => API.delete(`/api/products/${id}`);

// Faz S2: Admin Ürün CRUD (yeni — /api/admin/products mount'una bağlı)
export const adminCreateProduct = (data) => API.post(`/api/admin/products`, data);
export const adminUpdateProduct = (id, data) => API.put(`/api/admin/products/${id}`, data);
export const adminDeleteProduct = (id) => API.delete(`/api/admin/products/${id}`);
export const adminRestoreProduct = (id) => API.post(`/api/admin/products/${id}/restore`);
export const adminListProducts = (params = {}) => API.get(`/api/admin/products`, { params });
export const adminUploadProductImage = (file) => {
  const fd = new FormData();
  fd.append("image", file);
  return API.post(`/api/admin/products/upload-image`, fd, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// Bizimhesap-tarzi panel UX (2026-05-03):
// Toplu silme: { ids: [1,2,3] } - max 500, soft-delete, siparis gecmisi etkilenmez
export const adminBulkDeleteProducts = (ids) =>
  API.post(`/api/admin/products/bulk-delete`, { ids });
// Marka filtresi icin distinct aktif marka listesi
export const adminGetBrands = () => API.get(`/api/admin/products/brands`);
// Birim autocomplete icin distinct aktif birim listesi (Koli, Kilogram vb.)
export const adminGetUnits = () => API.get(`/api/admin/products/units`);

// F5: CSV import / export
export const importCsv = (type, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return API.post(`/api/admin/import/${type}`, fd, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};
export const exportCsvUrl = (type, params = "") =>
  `https://api.miksanplastik.com.tr/api/admin/export/${type}${params ? "?" + params : ""}`;
export const downloadExport = async (type, params = "") => {
  const r = await API.get(`/api/admin/export/${type}${params ? "?" + params : ""}`, { responseType: "blob" });
  return r.data;
};
export const downloadTemplate = (type) =>
  API.get(`/api/admin/export/templates/${type}`, { responseType: "blob" }).then(r => r.data);
export const cancelOrder = (id) => API.put(`/api/orders/${id}/cancel`);

// 5d Admin Sipariş Onay/Red/Manuel Fatura
export const approveOrder = (id, idempotency_key) =>
  API.post(`/api/admin/orders/${id}/approve`, { idempotency_key });
export const rejectOrder = (id, reason, idempotency_key) =>
  API.post(`/api/admin/orders/${id}/reject`, { reason, idempotency_key });
export const markOrderPaid = (id) =>
  API.post(`/api/admin/orders/${id}/mark-paid`, {});
export const markBhManual = (id, payload) =>
  API.post(`/api/admin/orders/${id}/mark-bh-manual`, payload);

// Faz A — State machine endpoint'leri
// Sipariş hangi statülere geçebilir? (frontend butonları için)
export const getOrderNextStates = (id) =>
  API.get(`/api/admin/orders/${id}/next-states`);
// Tek tıkla statü geçişi (BH+kargo+notify otomatik tetiklenir)
export const transitionOrder = (id, to_status, reason) =>
  API.post(`/api/admin/orders/${id}/transition`, { to_status, reason });

// Faz F — Admin Insights endpoint'leri
export const getDashboardKPI = () => API.get(`/api/admin/insights/dashboard`);
export const getCustomer360 = (userId) => API.get(`/api/admin/insights/customer/${userId}`);
export const getAdminNotifications = () => API.get(`/api/admin/insights/notifications`);
export const getMarketingSummary = () => API.get(`/api/admin/insights/marketing`);

// Faz D — Marketing API
export const getSegments = () => API.get(`/api/admin/marketing/segments`);
export const getSegmentMembers = (code, limit = 50) => API.get(`/api/admin/marketing/segments/${code}/members?limit=${limit}`);
export const reclassifySegments = () => API.post(`/api/admin/marketing/segments/reclassify-all`);
export const getDripCampaigns = () => API.get(`/api/admin/marketing/drip-campaigns`);
export const getSocialPosts = (params = {}) => API.get(`/api/admin/marketing/social-posts`, { params });
export const createSocialPost = (data) => API.post(`/api/admin/marketing/social-posts`, data);
export const cancelSocialPost = (id) => API.put(`/api/admin/marketing/social-posts/${id}/cancel`);

// Faz C — Purchase Orders API
export const getPurchaseOrders = (params = {}) => API.get(`/api/admin/purchase-orders/list`, { params });
export const getPOSuggestions = () => API.get(`/api/admin/purchase-orders/suggestions/list`);

// Faz G — System status
export const getSystemStatus = () => API.get(`/api/admin/system/status`);

// Faz E.8 (2026-05-16) — BH retry kuyrugu + sistem settings
export const getBhRetryQueue = () => API.get(`/api/admin/system/bh-retry-queue`);
export const retryBhInvoice = (orderId, force = false) =>
  API.post(`/api/admin/system/bh-retry/${orderId}`, { force: force ? 1 : 0 });
export const runBhRetryPass = () => API.post(`/api/admin/system/bh-retry-pass`);
export const getSystemSettings = () => API.get(`/api/admin/system/settings`);
export const updateSystemSettings = (data) => API.put(`/api/admin/system/settings`, data);
// Faz E.10 (2026-05-16): BH urun pull sync (INSERT-ONLY)
export const runBhProductSync = () => API.post(`/api/admin/system/bh-product-sync`);
export const getBhProductSyncLog = (limit = 50) =>
  API.get(`/api/admin/system/bh-product-sync-log?limit=${limit}`);

// F8: Entegrasyonlar (kargo, e-fatura, whatsapp, settings)
export const getCarriers = () => API.get(`/api/admin/kargo/carriers`);
export const getShipments = (params = {}) => API.get(`/api/admin/kargo/shipments`, { params });
export const createShipment = (data) => API.post(`/api/admin/kargo/shipments`, data);
export const trackShipment = (trackingNo) => API.get(`/api/admin/kargo/track/${encodeURIComponent(trackingNo)}`);
export const updateShipmentStatus = (id, data) => API.put(`/api/admin/kargo/shipments/${id}/status`, data);
export const cancelShipment = (id) => API.delete(`/api/admin/kargo/shipments/${id}`);

export const sendEfatura = (orderId, data = {}) => API.post(`/api/admin/efatura/send/${orderId}`, data);
export const getEfaturaStatus = (uuid) => API.get(`/api/admin/efatura/status/${uuid}`);
export const getEfaturaLog = (params = {}) => API.get(`/api/admin/efatura/log`, { params });
export const cancelEfatura = (uuid, reason) => API.post(`/api/admin/efatura/cancel/${uuid}`, { reason });

export const sendWhatsappTemplate = (data) => API.post(`/api/whatsapp/admin/send-template`, data);
export const getWhatsappMessages = (params = {}) => API.get(`/api/whatsapp/admin/messages`, { params });

// ===========================================================================
// Faz 9b — Email kampanya v2 helper'ları (Brevo SMTP migration sonrası)
// Eski /status /log /control endpoint'leri hâlâ çalışıyor (geriye uyumluluk),
// ama yeni admin UI bunları kullanır:
// ===========================================================================
export const ec_stats           = ()              => API.get(`/api/admin/email-campaign/stats`);
export const ec_segments        = ()              => API.get(`/api/admin/email-campaign/contacts/segments`);
export const ec_contacts        = (params = {})   => API.get(`/api/admin/email-campaign/contacts`, { params });
export const ec_contactCreate   = (data)          => API.post(`/api/admin/email-campaign/contacts`, data);
export const ec_contactUpdate   = (id, data)      => API.put(`/api/admin/email-campaign/contacts/${id}`, data);
export const ec_contactDelete   = (id)            => API.delete(`/api/admin/email-campaign/contacts/${id}`);
export const ec_campaigns       = ()              => API.get(`/api/admin/email-campaign/campaigns`);
export const ec_campaign        = (id)            => API.get(`/api/admin/email-campaign/campaigns/${id}`);
export const ec_campaignCreate  = (data)          => API.post(`/api/admin/email-campaign/campaigns`, data);
export const ec_campaignUpdate  = (id, data)      => API.put(`/api/admin/email-campaign/campaigns/${id}`, data);
export const ec_campaignStart   = (id)            => API.post(`/api/admin/email-campaign/campaigns/${id}/start`);
export const ec_campaignPause   = (id)            => API.post(`/api/admin/email-campaign/campaigns/${id}/pause`);
export const ec_campaignResume  = (id)            => API.post(`/api/admin/email-campaign/campaigns/${id}/resume`);
export const ec_campaignCancel  = (id)            => API.post(`/api/admin/email-campaign/campaigns/${id}/cancel`);
export const ec_campaignFinish  = (id)            => API.post(`/api/admin/email-campaign/campaigns/${id}/finish`);
export const ec_campaignLog     = (id, limit=100) => API.get(`/api/admin/email-campaign/campaigns/${id}/log?limit=${limit}`);
export const ec_campaignTestSend= (id, to_email)  => API.post(`/api/admin/email-campaign/campaigns/${id}/test-send`, { to_email });

export const getIntegrations = (module) => API.get(`/api/admin/integrations${module ? '/' + module : ''}`);
export const updateIntegration = (id, data) => API.put(`/api/admin/integrations/${id}`, data);
export const testIntegration = (module, data = {}) => API.post(`/api/admin/integrations/test/${module}`, data);

// Note 7 — order full-history (audit + push + shipments + efatura birleşik timeline)
export const getOrderFullHistory = (id) => API.get(`/api/admin/orders/${id}/full-history`);

// Analytics / Reports
export const getAnalyticsOverview = (days = 30) => API.get(`/api/admin/analytics/overview?days=${days}`);
export const getAnalyticsDaily = (days = 14) => API.get(`/api/admin/analytics/daily?days=${days}`);
export const getTodaySummary = () => API.get(`/api/admin/analytics/today-summary`);
export const getTopProducts = (days = 30, limit = 10) => API.get(`/api/admin/analytics/top-products?days=${days}&limit=${limit}`);
export const getSalesReport = (from, to) => API.get(`/api/admin/analytics/sales-report?from=${from}&to=${to}`);
export const getCustomerReport = (from, to) => API.get(`/api/admin/analytics/customer-report?from=${from}&to=${to}`);
export const getStockReport = () => API.get(`/api/admin/analytics/stock-report`);
export const getLowStock = () => API.get(`/api/admin/stock/low-stock`);
export const getActiveCampaigns = () => API.get(`/api/admin/campaigns`);

// Faz 12a (2026-04-29) — Audit Log + Sistem Sagligi
// audit-log: filter parametreleri obje olarak gecirilir
//   { action, actor, resource_type, from, to, q, limit, offset }
export const getAuditLog = (filters = {}) => {
  const qs = Object.entries(filters)
    .filter(([_, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => encodeURIComponent(k) + "=" + encodeURIComponent(v))
    .join("&");
  return API.get("/api/admin/audit-log" + (qs ? "?" + qs : ""));
};
export const getAuditLogActions = () => API.get("/api/admin/audit-log/actions");
export const getSystemHealth = () => API.get("/api/admin/system-health");